/* eslint-disable no-restricted-imports */
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { Flex, PartThumbnail, Text } from '@frontend/components';

import { formatPrice } from 'utils/formatters';

import {
  getAdjustments,
  getQuoteItems,
  getSelectedOptions,
} from '../../data/reducer';

const Wrapper = styled.div`
  border: 1px solid #ddd;
  margin-left: -10px;
  margin-right: -10px;
  overflow-x: auto;
`;

const StyledTable = styled.table`
  border-collapse: collapse;
  text-align: center;
  td,
  th {
    height: 89px;
    padding-bottom: 13px;
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 13px;
  }
  th {
    background: #cecece;
  }
`;

const PaymentSummary = () => {
  const adjustments = useSelector(getAdjustments);
  const quoteItems = useSelector(getQuoteItems);
  const selectedOptions = useSelector(getSelectedOptions);

  return (
    <Wrapper>
      <StyledTable>
        <tr>
          <th>Part</th>
          <th>Process</th>
          <th>Material</th>
          <th>Finish</th>
          <th>Unit Price</th>
          <th>Quantity</th>
          <th>Total Price</th>
        </tr>
        {(() => {
          const rows: React.ReactNode[] = [];
          quoteItems.forEach((quoteItem) => {
            if (selectedOptions[quoteItem.id] || adjustments[quoteItem.id]) {
              const component = quoteItem.rootComponent;
              const selectedOption = selectedOptions[quoteItem.id];
              const expedite = selectedOption?.expedite;
              const option = selectedOption
                ? {
                    ...selectedOption.quantity,
                    ...expedite,
                    unitPrice:
                      expedite?.unitPrice ??
                      selectedOption.manualTotalUnitPrice ??
                      selectedOption.quantity.totalUnitPrice,
                    quantity: selectedOption.quantity.quantity,
                  }
                : adjustments[quoteItem.id];
              const finishOps = component.finishes;
              rows.push(
                <tr>
                  <td>
                    <Flex direction="column">
                      <PartThumbnail
                        partFileUuid={component.part.primaryFileUuid}
                        filename={component.part.filename}
                        containsVirus={component.part.containsVirus}
                      />
                      <Text size="sm">{component.part.filename}</Text>
                    </Flex>
                  </td>
                  <td>{component.process ? component.process.name : '---'}</td>
                  <td>
                    {component.material
                      ? component.material.displayName
                      : '---'}
                  </td>
                  <td>
                    {finishOps.length > 0
                      ? finishOps.map((op) => op.name).join(' ,')
                      : '---'}
                  </td>
                  <td>{`${formatPrice(
                    option.unitPrice,
                    component.unitPricePrecision,
                  )}`}</td>
                  <td>{option.quantity}</td>
                  <td>{`${formatPrice(option.totalPrice)}`}</td>
                </tr>,
              );
            }
          });
          return rows;
        })()}
      </StyledTable>
    </Wrapper>
  );
};
export default PaymentSummary;
